import {gql} from "@apollo/client";


export const GET_SERVICE_FEEDBACK = gql`
  query GetServiceFeedback($id: ID!) {
    feedback: getServiceFeedback(id: $id) {
      _id
      code
      description
      region {
        _id
        name
        code
      }
      district {
          _id
          name
          code
      }
      contactPerson {
        fullName
        phoneNumber
        emailAddress
      }
      servicePointCode
      personnel  {
        ... on User {
          _id
          code
          firstName
          lastName  
          emailAddress
          phoneNumber
          profileImageUrl
        }
        ... on PartnerUser {
          _id
          code
          firstName
          lastName
          emailAddress
          phoneNumber
          profileImageUrl
        }
        ... on ContractorUser {
          _id
          code
          firstName
          lastName
          emailAddress
          phoneNumber
          profileImageUrl
        }
        ... on MeterContractorUser {
          _id
          code
          firstName
          lastName
          emailAddress
          phoneNumber
          profileImageUrl
        }
      }
      farmingOutContractor  {
        _id
        name
        code
      }
      contractor {
        _id
        name
        code
      }
      status
      type
      serviceItem {
          ... on Complaint {
            _id
            code
          }
      }
      answers
      submittedAt
      createdAt
      updatedAt
    }
  }
`;